import moment from 'moment';
import config from '../../config';

export const LIFETIME_COURSE_TAG = 'vitalicio';

export const hasLifetimeCourse = (courses) => {
  if (!courses || !Array.isArray(courses)) {
    return false;
  }
  return courses.some((course) => course?.tag === LIFETIME_COURSE_TAG);
};

export default (courses) => {
  const cfp60DiasTag = [
    'cfp-60',
    'cfp2021_1turma',
    'cfp2021_2turma',
    'cfp2021_4turma',
    'cfp2021_xp',
    'turma_cfp_alunos',
    'cfp-2021',
    'cfp2021_agosto',
    'cfp2021_agosto_alunos',
    'cfp2021_agosto_turma-0',
    'cfp2021_agosto_turma-4',
    'cfp-novembro-21',
    'cfp-teste-smart',
    'cfp-teste-smart_1',
  ];

  const canShowCourse = () => {
    if (!courses || !Array.isArray(courses)) {
      return false;
    }
    const today = new Date();
    let validation = false;
    courses.some((el) => {
      const validateDate = moment(el.data_fim_aulas).isBefore(today);
      return (validation = cfp60DiasTag.includes(el.tag) && validateDate);
    });
    return validation;
  };

  const canVisibleGabaritoro = () => {
    if (!courses || !Array.isArray(courses)) {
      return false;
    }
    const isCFP = courses.filter((course) => course.id_course_category === 1);
    return isCFP.length > 0;
  };

  return [
    {
      name: 'start',
      title: 'Início',
      link: true,
      show: false,
      showMobile: false,
    },
    {
      name: 'courses',
      title: 'Meus cursos',
      link: true,
      showMobile: false,
    },
    {
      name: 'user',
      title: 'Meu perfil',
      link: true,
      showMobile: false,
    },
    {
      name: 'mentorship',
      title: 'Mentorias',
      show: false && courses && canShowCourse(),
      showMobile: false,
    },
    // {
    //   name: 'questions',
    //   title: 'Questões',
    //   link: true,
    //   showMobile: false,
    // },
    {
      name: 'new-questions',
      title: 'Questões',
      link: true,
      showMobile: false,
    },
    {
      name: 'podcast',
      title: 'Podcast',
      link: true,
      showMobile: false,
    },
    {
      name: 'appQuiz',
      title: 'App Quiz',
      link: true,
      show: false,
      showMobile: true,
    },
    {
      name: 'cashback',
      title: 'Carteira',
      link: true,
      showMobile: true,
    },
    {
      name: 'gabaritoro',
      title: 'Gabaritoro',
      openURL: config.REACT_APP_GABARITORO_URL,
      show: canVisibleGabaritoro(),
      showMobile: true,
    },
    {
      name: 'contracts',
      title: 'Contratos',
      show: false,
      showMobile: false,
    },
    {
      name: 'notifications',
      title: 'Notificações',
      link: true,
      showMobile: false,
    },
    {
      name: 'indicatoro',
      title: 'IndicaToro',
      openURL: config.REACT_APP_INDICATORO_URL,
      showMobile: true,
    },
    {
      name: 'support',
      title: 'Suporte',
      openURL: config.REACT_APP_SUPPORT_URL,
      border: true,
      showMobile: true,
    },
    {
      name: 'lifetime-support',
      title: 'Suporte Vitalício',
      openURL: config.REACT_APP_LIFETIME_SUPPORT_URL,
      border: false,
      show: hasLifetimeCourse(courses),
      showMobile: true,
      premium: true,
    },
    {
      name: 'faq',
      title: 'FAQ',
      openURL: config.REACT_APP_FAQ_URL,
      showMobile: true,
    },
    {
      name: 'logout',
      title: 'Sair',
      showMobile: true,
    },
    {
      name: 'oldStudent',
      title: 'Área do aluno antigo',
      show: false,
      showMobile: false,
    },
  ];
};
